export const techAndMeasureTagTooltips = {
  investementExpenditure: [
    {
      value: null,
      text: 'Yatırım harcaması gerekmez'
    },
    {
      value: '$',
      text: 'Önerilen önlem veya teknoloji, 10,000 USD\'den daha düşük bir maliyeti ifade eder'
    },
    {
      value: '$$',
      text: 'Önerilen önlem veya teknoloji, 10,000 USD\'den yüksek ancak 150,000 USD\'den düşük bir maliyeti ifade eder'
    },
    {
      value: '$$$',
      text: 'Önerilen önlem veya teknoloji, 150.000 USD\'den yüksek ancak 500.000 USD\'den düşük bir maliyeti ifade eder.'
    },
    {
      value: '$$$$',
      text: 'Önerilen önlem veya teknoloji, 500.000 USD\'den yüksek bir maliyeti ifade eder.'
    }
  ],
  impactEnergy: [
    {
      value: 'düşük',
      text: 'Tasarruf, %15 veya daha düşük eşittir'
    },
    {
      value: 'orta',
      text: 'Tasarruf, %16 ile %30 arasındadır'
    },
    {
      value: 'yüksek',
      text: 'Tasarruf, %31 ile %60 arasındadır.'
    },
    {
      value: 'çok yüksek',
      text: 'Tasarruf, %60\'tan yüksektir.'
    }
  ],
  impactWater: [
    {
      value: 'düşük',
      text: 'Tasarruf, %15 veya daha düşük eşittir'
    },
    {
      value: 'orta',
      text: 'Tasarruf, %16 ile %30 arasındadır'
    },
    {
      value: 'yüksek',
      text: 'Tasarruf, %31 ile %60 arasındadır.'
    },
    {
      value: 'çok yüksek',
      text: 'Tasarruf, %60\'tan yüksektir.'
    }
  ]
};
